import _ from 'lodash';

import { toQuery } from '@/utils/infrastructure';
import { request } from '@/utils/infrastructure/communication';
import HttpService from './http';

export async function queryGoToAction(params = {}) {
  const fragments = [
    params?.processId || params?.ProcessId,
    params?.formId,
    params?.fieldId,
    params?.processInstanceId,
    params?.actionInstanceId,
  ].filter(Boolean);

  return request.post(`/processEngine/goToActionFromField/${fragments.join('/')}`);
}

export async function queryAutoComplete(params, route) {
  return request(route, {
    params,
  });
}

export async function queryPosition(params) {
  return request('/position', {
    params: toQuery(params),
  });
}

export async function queryUser(params) {
  return request('/user', {
    params: toQuery(params),
  });
}

export async function queryDataSelect(params, route) {
  if (params.method === 'post') return request.post(`/${route}`);
  return request(`/${route}`, {
    params: toQuery(params),
  });
}

export async function queryUserGroup(params) {
  return request('/userGroup', {
    params: toQuery(params),
  });
}

export async function queryProcess(params) {
  return request('/process', {
    params: toQuery(params),
  });
}

export async function queryProcessGroup(params) {
  return request('/processGroup', {
    params,
  });
}

export async function queryDbConnections(params) {
  return request('/databaseConnection', {
    params,
  });
}

export async function queryApiData({ route, httpMethod = 'get', params = {}, body }) {
  return HttpService.getInstance().request(`/${route}`, {
    method: _.toLower(httpMethod) ?? 'get',
    params,
    ...(_.toLower(httpMethod) === 'post' && { data: params?.body || body || {} }),
    headers: {
      ...(_.toLower(httpMethod) !== 'get' && { 'Content-Type': 'application/json' }),
    },
  });
}

export async function queryPatternDefinition(route) {
  return request(route, {});
}

export async function toExport({ route, httpMethod = 'post', data = {}, ...params }) {
  return request[_.toLower(httpMethod) ?? 'post'](`/${route}`, {
    params: toQuery(params),
    data,
  });
}

export async function toDownloadHTML({ route, httpMethod = 'get' }) {
  return request[_.toLower(httpMethod) ?? 'get'](`/${route}`, { responseType: 'blob' });
}

export async function toImport({ route, ...data }) {
  return request.post(`/processInstance/import/${route}`, { data });
}

//New Api
export async function getList({ route, params = {}, readPriority = false }) {
  return request(`/${route}`, { params: toQuery(params), readPriority });
}

export async function getById({ route, id, params = {} }) {
  return request(`/${route}/${id}`, { params: toQuery(params) });
}

export async function create({ route, data = {} }) {
  return request.post(`/${route}`, { data });
}

export async function update({ route, data = {} }) {
  return request.put(`/${route}`, { data });
}

export async function updateById({ route, id, data = {}, method = 'patch' }) {
  return request[method](`/${route}/${id}`, { data });
}

export async function remove({ route, id }) {
  return request.delete(`/${route}/${id}`, {});
}

export async function activate({ route, id, state }) {
  return request.post(`/${route}/activate/${id}/${state}`, {});
}

export async function userReset({ route, id, state }) {
  return request.post(`/${route}`, {});
}

export async function setDefault({ route, id, state }) {
  return request.post(`/${route}/setDefault/${id}`, {});
}

export async function toImportExcel({ route, ...data }) {
  return request.post(`/${route}/import`, { data });
}

export async function queryEditActive({ id, route }) {
  return request.post(`/${route}/activate/${id}`, {});
}
